import { useState, useEffect } from "react";
import { InputNumber, message } from "antd";
import { useQuery, useMutation } from "@tanstack/react-query";
import {
  StyledAntdTable,
  StyledButton,
  StyledAntdModal
} from "common/components/StyledElements";
import { useAuthContext } from "common/contexts/AuthContext";
import APIConstants from "common/constants/APIConstants";
import { api } from "common/utils/APIMethods";

const EditPreBatchModal = ({ batchId, onClose, onSuccess }) => {
  const { authConfig } = useAuthContext();
  const { getPreBatchById, updatePreBatch } = APIConstants;

  const [editable, setEditable] = useState(false);
  const [productQuantity, setProductQuantity] = useState(null);
  const [materials, setMaterials] = useState([]);

  const { data: batch } = useQuery({
    queryKey: ["batch", batchId],
    queryFn: () =>
      api({ url: `${getPreBatchById}/${batchId}` }, authConfig)
  });

  useEffect(() => {
    if (batch) {
      setProductQuantity(batch.productQuantity);
      setMaterials(batch.materials);
    }
  }, [batch]);

  const { mutate: updateMutate, isPending } = useMutation({
    mutationFn: (body) =>
      api(
        {
          url: updatePreBatch,
          method: "PUT",
          body
        },
        authConfig
      ),
    onSuccess: () => {
      message.success("Batch updated successfully");
      onSuccess();
    }
  });

  const handleSubmit = () => {
    updateMutate({
      batchId,
      productQuantity,
      materials
    });
  };

  const columns = [
    {
      title: "Material",
      dataIndex: "materialName"
    },
    {
      title: "Quantity",
      render: (_, record) => (
        <InputNumber
          disabled={!editable}
          value={record.inventoryQuantity}
          onChange={(value) =>
            setMaterials((prev) =>
              prev.map((m) =>
                m.productInventoryId === record.productInventoryId
                  ? { ...m, inventoryQuantity: value }
                  : m
              )
            )
          }
        />
      )
    }
  ];

  return (
    <StyledAntdModal
      open
      onCancel={onClose}
      footer={null}
      width={800}
      title="Edit Batch"
      destroyOnHidden
    >
      <div style={{ marginBottom: 20 }}>
        <div style={{ marginBottom: 8, fontWeight: 600 }}>Quantity To Produce</div>
        <InputNumber
          disabled
          value={productQuantity}
          onChange={setProductQuantity}
        />
      </div>

      <StyledAntdTable
        rowKey="productInventoryId"
        columns={columns}
        dataSource={materials}
        pagination={false}
      />

      <div style={{ marginTop: 20, textAlign: "right" }}>
        {!editable && (
          <StyledButton onClick={() => setEditable(true)}>
            Enable Editing
          </StyledButton>
        )}

        {editable && (
          <StyledButton
            type="primary"
            loading={isPending}
            onClick={handleSubmit}
          >
            Update
          </StyledButton>
        )}
      </div>
    </StyledAntdModal>
  );
};

export default EditPreBatchModal;
